import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';

import { useFeatureFlags } from '@/components/providers/FeatureFlagsProvider';
import { coverageQueries } from '@/lib/queries/coverage';
import { preLoadDefaultProject } from '@/lib/queries/project';

import { CoverageCharts } from './-components/CoverageCharts';
import CoverageTable from './-components/CoverageTable';

export const Route = createFileRoute('/_root/coverage/')({
  component: RouteComponent,
  loader: async ({ context: { queryClient } }) => {
    const defaultProject = await preLoadDefaultProject({
      context: { queryClient },
    });

    await queryClient.ensureQueryData(coverageQueries.list(defaultProject.id));

    return defaultProject;
  },
});

function RouteComponent() {
  const defaultProject = Route.useLoaderData();
  const { data: coverageResources } = useSuspenseQuery(
    coverageQueries.list(defaultProject.id),
  );

  const { FeatureSearchCoverage } = useFeatureFlags();
  if (FeatureSearchCoverage !== true) {
    return <Navigate to="/integrations" />;
  }

  return (
    <>
      <h1 className="lg:text-5xl md:text-3xl sm:text-xl text-zinc-950 dark:text-white text-center mb-2 font-medium">
        <FormattedMessage id="coverage.title" />
      </h1>
      <div className="p-4 space-y-8">
        <CoverageCharts resources={coverageResources} />
        <CoverageTable resources={coverageResources} />
      </div>
    </>
  );
}
